import { FC, PropsWithChildren, useState } from "react";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import { Timeline, Videocam } from "@mui/icons-material";
import FullScreenDialog from "../../FullScreenDialog";
import DownloadPdfButton from "../../DownloadPdfButton";
import OpenScoreSheetButton from "../../OpenScoreSheetButton";
import { useGameDataContext } from "@context/GameDataContext";
import ChallengeList from "../challengeList/ChallengeList";
import { useResponsiveContext } from "@context/ResponsiveContext";
import { GameProgress } from "@/models/gameState";
import { gameState } from "@/services/gameState";
import GameEventLog from "../../event-history/GameEventLog";
import OpenSettingsButton from "../../OpenSettingsButton";
import AppVersion from "../../AppVersion";

const ChallengeTabletActionButtons: FC = () => {
  const { onTablet } = useResponsiveContext();
  const { game } = useGameDataContext();
  const gameProgress = gameState("gameProgress");

  const [eventHistoryOpen, setEventHistoryOpen] = useState(false);
  const [challengeListOpen, setChallengeListOpen] = useState(false);

  const openGameEventLog = () => {
    setEventHistoryOpen(true);
  };

  const closeGameEventLog = () => {
    setEventHistoryOpen(false);
  };

  const openChallengeList = () => {
    setChallengeListOpen(true);
  };

  const closeChallengeList = () => {
    setChallengeListOpen(false);
  };

  if (!onTablet) {
    return null;
  }

  const ActionButton: FC<PropsWithChildren<{ label: string }>> = ({
    label,
    children,
  }) => {
    return (
      <Box
        flex={"1 1 0px"}
        minWidth={0}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        {children}
        <Typography
          variant={"caption"}
          textAlign={"center"}
          maxWidth={"100%"}
          whiteSpace={"nowrap"}
          overflow={"hidden"}
          textOverflow={"ellipsis"}
        >
          {label}
        </Typography>
      </Box>
    );
  };

  return (
    <Paper elevation={7} square>
      <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          width={"100%"}
          gap={1}
        >
          <FullScreenDialog
            show={eventHistoryOpen}
            handleClose={closeGameEventLog}
            title={"Ticker Nachrichten"}
          >
            <GameEventLog />
          </FullScreenDialog>
          <FullScreenDialog
            show={challengeListOpen}
            handleClose={closeChallengeList}
            title={"Challenges"}
          >
            <ChallengeList onChallengeSelect={closeChallengeList} />
          </FullScreenDialog>
          <ActionButton label={"Challenges"}>
            <IconButton onClick={openChallengeList}>
              <Videocam />
            </IconButton>
          </ActionButton>
          <ActionButton label={"Ticker"}>
            <IconButton onClick={openGameEventLog}>
              <Timeline />
            </IconButton>
          </ActionButton>
          <ActionButton label={"Einstellungen"}>
            <OpenSettingsButton />
          </ActionButton>
          <ActionButton label={"Challenge Protokoll"}>
            <DownloadPdfButton
              game={game}
              highlight={gameProgress.valueOf() >= GameProgress.GAME_FINISHED}
            />
          </ActionButton>
          <ActionButton label={"Spielberichtsbogen"}>
            <OpenScoreSheetButton />
          </ActionButton>
        </Box>
        <AppVersion
          align={onTablet ? "center" : "right"}
          showAlwaysOnState={true}
          width={"98vw"}
        />
      </Box>
    </Paper>
  );
};

export default ChallengeTabletActionButtons;
